import moment from "moment";
import { ASSIGNMENT_METHODS, INCOTERMS_CODES, getTenderDeadline } from "./newOrderPayload";

const numberOrNull = (value) =>
  value === "" || value == null ? null : Number(String(value).replace(",", "."));

export const parseAviationAssignment = (order = {}) => ({
  tnvedCode: order.tnvedCode || "",
  unitMeasurement: order.unitMeasurement || "Kg",
  assignmentMethod: ASSIGNMENT_METHODS.includes(order.assignmentMethod) ? order.assignmentMethod : "Tender",
  incoterms: order.incoterms || "",
  incotermsEnabled: Boolean(order.incoterms),
  auctionStep: order.bidReductionStep ?? "",
  extendAuction: Boolean(order.isAuctionExtended),
});

export const buildAviationOrderPayload = (data, p) => {
  const direct = p.assignmentMethod === "DirectAssignment";
  const auction = p.assignmentMethod === "Auction";
  const deadline = direct ? null : getTenderDeadline(p.tenderDateEnd, p.tenderEndTime);
  return {
    tenderDateEnd: deadline,
    order: {
      ...data,
      tnvedCode: p.tnvedCode || "",
      assignmentMethod: p.assignmentMethod,
      incoterms: p.incotermsEnabled ? p.incoterms : null,
      bidReductionStep: auction ? numberOrNull(p.auctionStep) : null,
      isAuctionExtended: auction && Boolean(p.extendAuction),
      tenderDateEnd: deadline,
      expeditorId: direct ? p.partner?.expeditorCompanyId : null,
      price: direct ? numberOrNull(p.price) : 0,
      netPrice: direct ? numberOrNull(p.price) : 0,
      currency: p.acceptedCurrency,
      acceptedCurrency: p.acceptedCurrency,
      weight: numberOrNull(data.weight),
      volume: numberOrNull(data.volume),
      unitMeasurement: p.unitMeasurement || "Kg",
    },
    expeditors: direct ? [] : p.partnersForTender.map((partner) => partner.expeditorCompanyId),
  };
};

export const validateAviationOrder = (p, t, now = new Date()) => {
  const errors = {};
  const required = t("ordersCreate.validation.fillData");
  for (const field of [
    "countryFrom",
    "countryTo",
    "cityFrom",
    "cityTo",
    "addressFrom",
    "addressTo",
    "senderName",
    "recipientName",
    "categoryName",
  ]) {
    if (!p[field] || (typeof p[field] === "string" && !p[field].trim())) errors[field] = required;
  }
  for (const field of ["weight", "volume"]) {
    const value = numberOrNull(p[field]);
    if (value !== null && (!Number.isFinite(value) || value < 0 || String(p[field]).length > 8))
      errors[field] = required;
  }
  if (p.incotermsEnabled && !INCOTERMS_CODES.includes(p.incoterms)) errors.incoterms = required;
  if (!ASSIGNMENT_METHODS.includes(p.assignmentMethod)) errors.assignmentMethod = required;
  if (p.assignmentMethod === "DirectAssignment") {
    if (!p.partner?.expeditorCompanyId) errors.partner = required;
    if (!(numberOrNull(p.price) > 0) || !Number.isFinite(numberOrNull(p.price)))
      errors.price = t("ordersCreate.validation.specifyPriceError");
    if (!p.acceptedCurrency) errors.acceptedCurrency = t("ordersCreate.validation.selectCurrency");
  } else {
    if (!p.partnersForTender?.length) errors.partnersForTender = required;
    if (!p.tenderDateEnd) errors.tenderDateEnd = required;
    if (!p.tenderEndTime) errors.tenderEndTime = required;
    if (!p.acceptedCurrency) errors.acceptedCurrency = t("ordersCreate.validation.selectCurrency");
    const deadline = getTenderDeadline(p.tenderDateEnd, p.tenderEndTime);
    if (
      p.tenderDateEnd &&
      p.tenderEndTime &&
      (!deadline || (!p.isEdit && moment(deadline).isSameOrBefore(now)))
    ) {
      errors.tenderDateEnd = t("unifiedOrder.futureDeadline");
    }
  }
  if (
    p.assignmentMethod === "Auction" &&
    p.auctionStep !== "" &&
    p.auctionStep != null &&
    (!(numberOrNull(p.auctionStep) > 0) || !Number.isFinite(numberOrNull(p.auctionStep)))
  )
    errors.auctionStep = required;
  return errors;
};
